import type { Agent } from "../types";

export const AGENTS: Agent[] = [
  { id: "comercial",   nome: "Comercial Técnico",   descricao: "Orçamentos, RFQ, observações comerciais." },
  { id: "compras",     nome: "Compras / Importação", descricao: "E-mails fornecedor, Incoterms, custo importação." },
  { id: "engenharia",  nome: "Engenharia / Datasheet", descricao: "Datasheets, part numbers, equivalência." },
  { id: "financeiro",  nome: "Financeiro / Margem", descricao: "Preço mínimo, margem, risco de prejuízo." },
  { id: "code",        nome: "Code / SupriCRM",     descricao: "Copiloto de engenharia do SupriCRM." },
];
